import gql from 'graphql-tag'
import { gridProduct } from './fragments'

const mutation = gql`
mutation setGridProduct($categoryId: ID! $position: Int!, $productId: ID) {
	cashAssist {
		setGridProduct(categoryId: $categoryId, position: $position, productId: $productId) {
	    ...gridProduct
	  }
	}
}
${gridProduct}`

export default mutation
